/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSubjectStatus.defs.js'
export { main as default } from './getSubjectStatus.defs.js'
